import type { OutreachPresenceEntry } from '@aegislab/shared';

/**
 * 탭 머리 오른쪽 문구 — IA §3-7. 자기 자신은 빼고 나라를 붙인다(조사 §3-1).
 *
 * 한 사람이면 `박인혜님이 작업 중 · US, JP`, 여럿이면 사람마다 나라를 붙여
 * `박인혜(US) · 이강주(JP)님이 작업 중`. 아무도 없으면 `null` 이라 자리를 그리지 않는다.
 */
export function outreachPresenceLabel(
  items: readonly OutreachPresenceEntry[],
  selfId: string | undefined
): string | null {
  const people = new Map<string, { name: string; countries: string[] }>();
  for (const item of items) {
    if (item.userId === selfId) continue;
    const person = people.get(item.userId) ?? { name: item.username, countries: [] };
    if (!person.countries.includes(item.country)) person.countries.push(item.country);
    people.set(item.userId, person);
  }
  const others = [...people.values()];
  const [first] = others;
  if (first === undefined) return null;
  if (others.length === 1) return `${first.name}님이 작업 중 · ${first.countries.join(', ')}`;
  return `${others.map((p) => `${p.name}(${p.countries.join(', ')})`).join(' · ')}님이 작업 중`;
}
